import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory, Link } from 'react-router';
import ProductGroup from './product/ProductGroup';
import ProductGroupsMobile from './product/ProductGroupsMobile';
import ProductTile from './product/ProductTile';
import ProductTileWater from './product/ProductTileWater';
import MediaQuery from "react-responsive";
import { Carousel } from 'react-responsive-carousel';

import { saveSelected, getSelected, restartConfigurator } from '../actions';
import find from 'lodash/find';
import 'react-responsive-carousel/lib/styles/carousel.css';

import fetchJsonp from 'fetch-jsonp';
import tracking from '../services/Tracking';
import 'picturefill';
import * as qwest from 'qwest';
import { localeFormatted, configuratorType } from '../i18n.js';

import { FormattedMessage } from 'react-intl';
console.log('configuratorType result: ', configuratorType);
const imageSKUMap = {
    "27744000": "27743000",
    "27748000": "27745000",
    "27732000": "27731000",
    "27334000": "27733000",
    "27704000": "27653000",
    "27746000": "27745000",
    "26062000": "26052000",
    "26063000": "26053000",
    "26064000": "26054000",
    "26065000": "26055000",
    "26066000": "26056000",
    "26070000": "26060000",
    "26071000": "26061000",
    "27734000": "27733000",
    "27736000": "27735000",
    "27738000": "27737000",
    "27750000": "27749000",
    "27265000": "27224000"
};

class Result extends React.Component {
  constructor() {
    super();

    this.state = {
      currentSlide: 0,
      productGroups: {},
      bundle: [],
      showModal: false,
    };
  }

  componentDidMount() {
    const { results, products } = this.props;

    if (!results.length > 0) {
      browserHistory.push('/lv_lv/watersystems/configurator');
      return false;
    }
 
    // eslint-disable-next-line no-undef
    picturefill();

    if (products) {
      this.initState(results, products);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { results, products } = nextProps;

    this.initState(results, products);
  }

  componentDidUpdate() {
    // eslint-disable-next-line no-undef
    picturefill();
  }

  initState(results, products) {
    if (products.length > 0 && results.length > 0) {
      const productGroups = results[0]
        .map(group => ({
          bundle: group.bundle
            .map(id => find(products, { id }))
            .filter(product => product !== undefined)
            .map(this.addImages),
          products: group.products
            .map(id => find(products, { id }))
            .filter(product => product !== undefined)
            .map(this.addImages),
        }));
      
      this.setState({
        productGroups,
        bundle: productGroups[this.state.currentSlide] ? productGroups[this.state.currentSlide].bundle : [],
      });
    }
  }


  addImages(product){
    const imageCode = imageSKUMap[product.id] ? imageSKUMap[product.id] : product.id;
    if( imageSKUMap[product.id]){
        console.log('mapped', product.id, 'to', imageCode); // eslint-disable-line no-console
    }
    const images = {
     image: `//cdn.cloud.grohe.com/prod/${imageCode.substr(0,1)}0/${imageCode.substr(0,2)}/${imageCode}/640/${imageCode}.jpg`,
     imageMedium: `//cdn.cloud.grohe.com/prod/${imageCode.substr(0,1)}0/${imageCode.substr(0,2)}/${imageCode}/480/${imageCode}.jpg`,
     imageSmall: `//cdn.cloud.grohe.com/prod/${imageCode.substr(0,1)}0/${imageCode.substr(0,2)}/${imageCode}/320/${imageCode}.jpg`
    };
    return Object.assign({},product,images);
  }

  onChangeSlide(i) {
    this.setState({
      currentSlide: i,
      bundle: this.state.productGroups[i].bundle,
    });
  }

  downloadPDF(products = ['26053000']) {

    tracking.event(products.join('|'),'prepare download','notepad');
    const url = `https://application.grohe.com/gateway/specification/${localeFormatted}/`;
    qwest.post(url, {
      catalogue: {
        input: {
          timestamp: Date.now() / 1000 | 0,
        },
        products,
      },
    }, {
      cache: true,
      headers: {
        "Accept": "application/json",
      },
    })
    .then((xhr, response) => {
      let json = JSON.parse(unescape(response));
      if (json.file) {
        const interval = setInterval(() => {
          fetchJsonp(`https://specification.grohe.com/check/?callback=jQuery17105124361561611295_1416404594521&file=${encodeURIComponent(json.file)}`, {
            jsonpCallbackFunction: 'jQuery17105124361561611295_1416404594521',
          })
            .then((response) => {
              return response.json();
            })
            .then((responseJSON) => {
              if (responseJSON.status === 'file-ready') {
                clearInterval(interval);
                window.location = `https://specification.grohe.com/delivery/?file=${json.file}`;
              }
            }).catch(() => {
            clearInterval(interval);
          });
        }, 500);
      }
    })
    .catch((e, xhr, response) => {
      console.log(e, xhr, response); // eslint-disable-line no-console
    });
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { bundle, productGroups } = this.state;
    // TODO Only used once, never changed. Make const instead.
    // But ProductGroupsMobile doesn't use index prop. So maybe obsolete.
    let tmpi = 0;

    // check if swiper indicators needs to be shown
    const showResultIndicators = productGroups.length > 1 ? true : false;

    return (
      <div className="result">
        {productGroups.length > 0 && (
          <div>
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1 className="text-uppercase headline headline--centerOnMD headline--h1 headline--result">
                    <span className="headline__inner"><FormattedMessage id="results.title" values={{ productGroupsCount: productGroups.length }} /></span>
                  </h1>
                </div>
              </div>
            </div>
              <MediaQuery maxWidth={767}>
                <ProductGroupsMobile index={tmpi} data={productGroups} onClickDownload={this.downloadPDF} />
              </MediaQuery>
              <MediaQuery minWidth={768}>
                <div className="container">
                  <Carousel
                    axis="horizontal"
                    showThumbs={false}
                    showArrows={true}
                    showStatus={false}
                    showIndicators={showResultIndicators}
                    selectedItem={this.state.currentSlide}
                    onChange={(i) => this.onChangeSlide(i)}
                  >
                    {productGroups.map((productGroup, i) => (
                      <div key={i}>
                        <ProductGroup index={i} data={productGroup} productGroupsLength={productGroups.length} onClickDownload={this.downloadPDF} />
                      </div>
                    ))}
                  </Carousel>
                </div>
              </MediaQuery>
          </div>
        )}
        {bundle.length > 0 && (
          <MediaQuery minWidth={768}>
            <div className="separator">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <h1 className="text-uppercase headline headline--centerOnMD headline--h1 headline--result">
                      <span className="headline__inner"><FormattedMessage id="results.bundle.title" /></span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              {configuratorType === 'shower' &&
              <div className="row">
                {bundle.map((product, i) => (
                  <div key={i} className="col-md-3">
                    <ProductTile data={product} />
                  </div>
                ))}
              </div>
              }
              {configuratorType === 'water' &&
                <div>
                  {bundle.map((product, i) => (
                    <div key={i}>
                      <ProductTileWater data={product} />
                    </div>
                  ))}
                </div>
              }
            </div>
          </MediaQuery>
        )}

        <div className="container result-reset">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <h2 className="headline headline--h2">
                <FormattedMessage id="results.newConfiguration.title" />
              </h2>
            </div>
            <div className="col-sm-12 col-md-5">
              <Link to="/lv_lv/watersystems/configurator" onClick={() => tracking.event('', 'restart')} className="btn btn-block btn-primary button button--result">
                <FormattedMessage id="results.newConfiguration.buttonText" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Result.propTypes = {
  results: PropTypes.array.isRequired,
  products: PropTypes.array.isRequired,
  saveSelected: PropTypes.func.isRequired,
  getSelected: PropTypes.func.isRequired,
  restartConfigurator: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    results: state.configurator.results,
    products: state.data.products,
  };
}

const actions = { saveSelected, getSelected, restartConfigurator };
function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Result);


// WEBPACK FOOTER //
// ./src/components/Result.js